import { useWindowSize, DeviceSize } from 'hooks/useWindowSize';
import React, { useState, useEffect, useRef } from 'react';
import {
  ChatBetaContainer,
  ChatBetaDescriptionArrow,
  ChatBetaDescriptionBody,
  ChatBetaDescriptionContainer,
  ChatBetaDescriptionHeader,
  ChatBetaDescriptionTitle,
  ChatBetaText,
  ChatBetaTextContainer
} from './styles';

export const ChatBetaNote = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const { deviceSize } = useWindowSize();
  const isMobile = deviceSize === DeviceSize.SMALL;
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handleTouch = (e: TouchEvent) => {
      setIsOpen(false);
    };

    document.addEventListener('touchstart', handleTouch);

    return () => {
      document.removeEventListener('touchstart', handleTouch);
    };
  }, [isOpen]);

  return (
    <ChatBetaContainer id="chat-beta-container" ref={containerRef}>
      <ChatBetaTextContainer onClick={() => isMobile && setIsOpen(true)}>
        <ChatBetaText>BETA</ChatBetaText>
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.04995 8.4002H6.94995V5.4002H6.04995V8.4002ZM6.49733 4.5002C6.62408 4.5002 6.7312 4.45732 6.8187 4.37157C6.9062 4.28582 6.94995 4.17957 6.94995 4.05282C6.94995 3.92607 6.90708 3.81895 6.82133 3.73145C6.73558 3.64395 6.62933 3.6002 6.50258 3.6002C6.37583 3.6002 6.2687 3.64307 6.1812 3.72882C6.0937 3.81457 6.04995 3.92082 6.04995 4.04757C6.04995 4.17432 6.09283 4.28145 6.17858 4.36895C6.26433 4.45645 6.37058 4.5002 6.49733 4.5002ZM6.50345 10.8002C5.84278 10.8002 5.22078 10.6752 4.63745 10.4252C4.05412 10.1752 3.5437 9.83145 3.1062 9.39395C2.6687 8.95645 2.32495 8.4462 2.07495 7.8632C1.82495 7.2802 1.69995 6.65728 1.69995 5.99445C1.69995 5.33161 1.82495 4.71061 2.07495 4.13145C2.32495 3.55228 2.6687 3.04395 3.1062 2.60645C3.5437 2.16895 4.05395 1.8252 4.63695 1.5752C5.21995 1.3252 5.84287 1.2002 6.5057 1.2002C7.16853 1.2002 7.78953 1.3252 8.3687 1.5752C8.94787 1.8252 9.4562 2.16895 9.8937 2.60645C10.3312 3.04395 10.675 3.55319 10.925 4.1342C11.175 4.71528 11.3 5.33611 11.3 5.9967C11.3 6.65736 11.175 7.27936 10.925 7.8627C10.675 8.44603 10.3312 8.95645 9.8937 9.39395C9.4562 9.83145 8.94695 10.1752 8.36595 10.4252C7.78487 10.6752 7.16403 10.8002 6.50345 10.8002ZM6.49995 9.9002C7.58328 9.9002 8.50412 9.52103 9.26245 8.7627C10.0208 8.00436 10.4 7.08353 10.4 6.0002C10.4 4.91686 10.0208 3.99603 9.26245 3.2377C8.50412 2.47936 7.58328 2.1002 6.49995 2.1002C5.41662 2.1002 4.49578 2.47936 3.73745 3.2377C2.97912 3.99603 2.59995 4.91686 2.59995 6.0002C2.59995 7.08353 2.97912 8.00436 3.73745 8.7627C4.49578 9.52103 5.41662 9.9002 6.49995 9.9002Z"
            fill="black"
          />
        </svg>
      </ChatBetaTextContainer>
      <ChatBetaDescriptionContainer forceOpen={isOpen} className="chat-beta-description-container">
        <ChatBetaDescriptionArrow>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
            <path
              d="M8.64344 1.25221C9.40957 0.545015 10.5904 0.545017 11.3566 1.25221L19.2413 8.53039C20.5791 9.76529 19.7053 12 17.8847 12L2.1153 12C0.29468 12 -0.579057 9.76528 0.758742 8.53039L8.64344 1.25221Z"
              fill="black"
            />
          </svg>
        </ChatBetaDescriptionArrow>
        <ChatBetaDescriptionHeader>
          <ChatBetaDescriptionTitle>Beta</ChatBetaDescriptionTitle>
        </ChatBetaDescriptionHeader>
        <ChatBetaDescriptionBody>
          This assistant is currently in beta and still learning. It’s here to help you discover products based on your
          preferences, but its recommendations might not be perfect or comprehensive.
        </ChatBetaDescriptionBody>
        <br />
        <ChatBetaDescriptionBody>
          Please double-check product details before making a purchase, and don’t hesitate to reach out to our support
          team if you have any questions. Your feedback helps us improve — thanks for being part of the beta!
        </ChatBetaDescriptionBody>
      </ChatBetaDescriptionContainer>
    </ChatBetaContainer>
  );
};
